import React from 'react';

// Mirrors PROFILE_GENDER on the server.
export const GENDER_FEMALE = 2;
export const GENDER_MALE = 4;
export const GENDER_NON_BINARY = 8;

// `︎` is the text variation selector — forces the glyph to render in
// monochrome text style instead of as a colored emoji (macOS/iOS otherwise
// renders ⚧ as the trans flag emoji).
export const GENDER_STYLE: Record<number, { symbol: string; color: string }> = {
  [GENDER_FEMALE]: { symbol: '♀︎', color: 'pink' },
  [GENDER_MALE]: { symbol: '♂︎', color: 'blue' },
  [GENDER_NON_BINARY]: { symbol: '⚧︎', color: 'teal' },
};

interface GenderTagProps {
  gender: unknown;
  style?: React.CSSProperties;
  className?: string;
  mr?: number;
}

export const GenderTag = ({ gender, style, className, mr }: GenderTagProps) => {
  const info = typeof gender === 'number' ? GENDER_STYLE[gender] : undefined;
  if (!info) return null;
  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: 'var(--fs-xs)',
        fontWeight: 600,
        borderRadius: 99,
        padding: '1px 5px',
        background: `var(--${info.color}-subtle, var(--bg-muted))`,
        color: `var(--${info.color}-text, var(--text-secondary))`,
        marginRight: mr != null ? mr * 4 : undefined,
        flexShrink: 0,
        ...style,
      }}
    >
      {info.symbol}
    </span>
  );
};
